import { useTheme } from 'styled-components';

/**
 * [green, purple, blue, gray]
 */
export const useColors = (offset: number = 0) => {
  const theme: any = useTheme();

  return [
    theme.colors.primary[400 + offset],
    theme.colors.secondary[400 + offset],
    theme.colors.tertiary[500 + offset],
    theme.colors.gray[300 + offset],
  ];
};

export default undefined;
